import React from "react";
import { LoaderContainer } from "./Loader.style";

const LoaderElement = () => {
  return (
    <LoaderContainer className="loader">
      <span>C</span>
      <span>H</span>
      <span>A</span>
      <span>R</span>
      <span>G</span>
      <span>E</span>
      <span>M</span>
      <span>E</span>
      <span>N</span>
      <span>T</span>
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </LoaderContainer>
  );
};

export default LoaderElement;
